<template>
  <!-- <div :class="classObj" class="app-wrapper">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <sidebar class="sidebar-container" />
    <div class="main-container">
      <div :class="{'fixed-header':fixedHeader}">
        <navbar />
      </div>
      <app-main />
    </div>
  </div>-->
  <iframe width="100%" src="https://landings.bee-seller.com/6Uhrm2jGR4Uy9xIBZUiF5QxfsRg2?_gl=1*11e868n*_gcl_au*MTY3MTU5Mzc2Ni4xNjg3ODEyOTIw&_ga=2.3255344.1807819830.1688039042-961601568.1687812920" />
</template>

<script>
// import { AppMain, Navbar, Sidebar } from './components';
import ResizeMixin from './mixin/ResizeHandler';
import { mapState } from 'vuex';

export default {
    name: 'Layout',
    components: {
        // AppMain,
        // Navbar,
        // Sidebar
    },
    mixins: [ResizeMixin],
    computed: {
        ...mapState({
            sidebar: state => state.app.sidebar,
            device: state => state.app.device,
            fixedHeader: true
        }),
        classObj() {
            return {
                hideSidebar: !this.sidebar.opened,
                openSidebar: this.sidebar.opened,
                withoutAnimation: this.sidebar.withoutAnimation,
                mobile: this.device === 'mobile'
            };
        }
    },
    methods: {
        handleClickOutside() {
            this.$store.dispatch('app/closeSideBar', { withoutAnimation: false });
        }
    }
};
</script>

<style lang="scss" scoped>
  iframe {
    border: 0;
    height: 100%;
    position: absolute;
  }
  .app-wrapper {
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    &.mobile.openSidebar {
      position: fixed;
      top: 0;
    }
  }

  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    transition: width 0.28s;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }
  .main-container {
      width: calc(100% - 64px);
  }
  .sidebar-container {
      height: 100vh;
      background-color: #f8f9fa;
      border-right: solid 1px #e6e6e6;
  }
  .openSidebar {
      .sidebar-container {
          width: 15%;
          position: sticky;
          top: 0;
          overflow-y: auto;
          &::-webkit-scrollbar {
              width: 0px;
          }
      }
      .main-container {
          width: 85%;
      }
  }

  .mobile .fixed-header {
    width: 100%;
  }
</style>
